import { takeLatest } from 'redux-saga/effects';
import {	
    doAskCopilotSuccess, doAskCopilotFail,
	doAgentChatSuccess, doAgentChatFail,
} from './copilotState';

import createCrudService from '../../services/crudservice';
import createAIAgentService from '../../services/aiagentservice';
import { 
	doCrudCall, LOADING_MSG
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/copilot');

const aiAgentService = createAIAgentService();

function* doAskCopilot(data) {
	yield doCrudCall(
		() => crudService.doPostRequest(`general-accountant`, data.payload), 
		doAskCopilotSuccess,
		doAskCopilotFail, 
		null, null, 'Thinking...'
	);
}

function* doAgentChat(data) {
	yield doCrudCall(
		() => aiAgentService.invokeAgent(data.payload, 'chat-hr'),
		doAgentChatSuccess,
		doAgentChatFail, 
		null, null, 'Thinking...'
	);
}

function* copilotSaga() {
	yield takeLatest('copilot/doAskCopilot', doAskCopilot);
	yield takeLatest('copilot/doAgentChat', doAgentChat);
}

export default copilotSaga;
